import { default as bulkImportQueries } from "bulkImport/queries";
import { default as userQueries } from "resources/users/queries";

export * from "bulkImport/queries";

export { bulkImportQueries, userQueries };

export const customDataProivderQueries = [bulkImportQueries, userQueries];
